import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'

export default {
  VueCtkDateTimePicker
}



// WEBPACK FOOTER //
// ./src/app/tenant/access/form/resources/components.js